export const ALTO_FONTS = {
  BODY: {
    REGULAR: 'Inter-Regular',
    REGULAR_ITALIC: 'Inter-Italic',
    SEMIBOLD: 'Inter-SemiBold',
    SEMIBOLD_ITALIC: 'Inter-SemiBoldItalic',
    BOLD: 'Inter-Bold',
    BOLD_ITALIC: 'Inter-BoldItalic',
  } as const,
  HEADER: {
    REGULAR: 'GalaxieCopernicus-Book',
    SEMIBOLD: 'GalaxieCopernicus-Semibold',
  } as const,
} as const;

export const FUZE_HEALTH_FONTS = {
  BODY: {
    REGULAR: 'Inter-Regular',
    REGULAR_ITALIC: 'Inter-Italic',
    SEMIBOLD: 'Inter-SemiBold',
    SEMIBOLD_ITALIC: 'Inter-SemiBoldItalic',
    BOLD: 'Inter-Bold',
    BOLD_ITALIC: 'Inter-BoldItalic',
  } as const,
  HEADER: {
    REGULAR: 'Inter-Regular',
    SEMIBOLD: 'Inter-Semibold',
  } as const,
} as const;

export type FontTokens = typeof ALTO_FONTS | typeof FUZE_HEALTH_FONTS;
let FONT: FontTokens = ALTO_FONTS;

export const setFonts = (font: FontTokens) => {
  FONT = font;
};

export { FONT };
